import {
  SET_USER,
  SET_USER_SUCCESS,
  SET_USER_FAILURE,
  SET_USER_TOKEN_SUCCESS,
  LOG_OUT_USER_SUCCESS,
  LOG_OUT_USER,
  LOG_OUT_USER_FAILURE,
  CLEAR_ERRORS
} from "../constants/authActionsType";
import {
  UPDATE_ACCOUNT_INFO,
  UPDATE_ACCOUNT_INFO_SUCCESS
} from "../constants/userActionType";

const initialState = {
  user: { }, // This is a workaround because there is not time to install and use JWT for gards (plain localstorage is no safe because data can be handle)
  token: "",
  isUserLoggedIn: false,
  isLogOutSuccess: false,
  isLoading: false,
  isLoadingUpdate: false,
  error: ""
};

export const userReducer = (state = initialState, { data, error, type }) => {
  switch (type) {
    case SET_USER:
    case LOG_OUT_USER:
      return {
        ...state,
        isLoading: true
      };

    case SET_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isUserLoggedIn: true,
        user: {
          ...data
        }
      };
    case SET_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        isUserLoggedIn: false,
        error
      };
    case LOG_OUT_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        isUserLoggedIn: true,
        error
      };
    case SET_USER_TOKEN_SUCCESS:
      return {
        ...state,
        token: data
      };

    case LOG_OUT_USER_SUCCESS:
      return {
        ...initialState,
        user: {},
        isLogOutSuccess: true,
        isUserLoggedIn: false
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: ""
      };

    case UPDATE_ACCOUNT_INFO:
      return {
        ...state,
        isLoadingUpdate: true
      };

    case UPDATE_ACCOUNT_INFO_SUCCESS:
      return {
        ...state,
        isLoadingUpdate: false,
        user: {
          ...state.user,
          full_name: data.full_name,
          email: data.email,
          phone_number: data.phone_number
        }
      };

    default:
      return state;
  }
};
